import script from "./FormSection.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSection.vue?vue&type=script&setup=true&lang=js"

export default script